import axios from 'axios'
import { Request } from '@/domain/Request'

/**
 * 検索条件
 */
export class SerchConditon {
    /** 受付番号 */
    requestNo = ""
    /** 期間開始日 */
    startOn = ""
    /** 期間終了日 */
    endOn = ""
    /** 顧客都道府県コード */
    customerPrefectureCode = ""
    /** 顧客コード */
    customerCode = ""
    /** 顧客枝番 */
    customerBranchNumber = ""
    /** 顧客名 */
    customerName = ""
    /** 検査依頼種別 */
    requestType: number | null = null
    /* 有効 */
    isActive = true

    /* 画面用 */
    /** 期間タイプ */
    dateType = 3

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<SerchConditon>) {
        Object.assign(this, init)
    }
}

/**
 * 検査一覧サービス
 */
export default class InspectsService {
    /** インスタンス */
    private static _instance: InspectsService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new InspectsService();
        }
        return this._instance;
    }

    /**
     * 検査一覧を検索
     */
    public async findAll(serchConditon: SerchConditon): Promise<Request[]> {
        return await axios.get("/api/inspects", {params: serchConditon})
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as Request[]).map(x => new Request({ ...x }))
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }
}
